import { render, staticRenderFns } from "./BRIBERY&POLICY.vue?vue&type=template&id=aeab9bba&scoped=true&"
import script from "./BRIBERY&POLICY.vue?vue&type=script&lang=js&"
export * from "./BRIBERY&POLICY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeab9bba",
  null
  
)

export default component.exports